import { render, staticRenderFns } from "./userHeadUpload.vue?vue&type=template&id=da6c0732&scoped=true&"
import script from "./userHeadUpload.vue?vue&type=script&lang=js&"
export * from "./userHeadUpload.vue?vue&type=script&lang=js&"
import style0 from "./userHeadUpload.vue?vue&type=style&index=0&id=da6c0732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6c0732",
  null
  
)

export default component.exports